// Leaf module for token storage keys — safe to import from anywhere
// (notably ModalService) without dragging in AuthenticationService,
// whose module graph reaches app.component and causes circular-init
// issues.
export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';

export function hasStoredAccessToken(): boolean {
  const token = localStorage.getItem(ACCESS_TOKEN);
  return token !== null && token !== '';
}
